<template>
  <div>
    <form class="form-horizontal">
      <h1 class="section-divider">
        {{ $t('question.answer') }}
        <span>
          <i
            class="far fa-question-circle"
            v-tooltip="
              'Provide your answers here. To choose correct answer click radio button.'
            "
          ></i
        ></span>
      </h1>
      <div class="answer-contianer ts-overflow-x-hidden">
        <ts-card-wrapper style="background-color: #f2f3f4;">
          <div class="row" v-for="(chunk, index) in answerChunks" :key="index">
            <div
              class="col-sm-12 col-lg-6 col-md-6"
              v-for="(answer, key) in chunk"
              :key="key"
            >
              <div class="form-group">
                <div class="ts-space-x-2">
                  <label class="ts-inline-block ts-font-bold">{{
                    answer.answer_prefix
                  }}</label>
                  <ts-radio
                    class="ts-inline-block"
                    :value="answer.id"
                    :name="'is_correct'"
                    v-model="selected"
                    ><span
                      class="text-green ts-font-bold"
                      v-if="answer.is_correct"
                      ><i class="fas fa-check"></i>
                      {{ $t('eschool.correctAnswer') }}</span
                    ></ts-radio
                  >
                </div>
                <ckeditor
                  :editor="editor"
                  v-model="answer.answers"
                  :config="editorConfig"
                ></ckeditor>
                <div
                  class="validate"
                  v-if="
                    errors.has('answer_list.' + (answer.id - 1) + '.answers')
                  "
                >
                  {{
                    errors.first('answer_list.' + (answer.id - 1) + '.answers')
                  }}
                </div>
                <a
                  v-if="answer.id > min_answer_choice"
                  href="#"
                  class="ts-font-bold text-danger"
                  @click.prevent="removeAnswer(answer)"
                  >{{ $t('eschool.remove') }}</a
                >
              </div>
            </div>
          </div>
          <div class="row" v-if="model.answer_list.length <= 25">
            <div class="col-lg-12">
              <a
                href="#"
                class="ts-font-bold text-primary"
                @click.prevent="addAnswer"
                ><i class="fas fa-plus"></i> {{ $t('eschool.addNewChoice') }}</a
              >
            </div>
          </div>
        </ts-card-wrapper>
      </div>
      <div class="ts-mb-4">
        <div class="validate ts-font-bold" v-if="errors.has('answer_list')">
          {{ errors.first('answer_list') }}
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

import Vue from 'vue'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
Vue.use(CKEditor)

export default {
  name: 'multipleChoice',
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      model: {},
      selected: null,
      min_answer_choice: 4,
      answer_prefix: [],
      new_answer: {
        question_id: 0,
        answer_id: 0,
        answers: '',
        answer_prefix: '',
        is_correct: false,
        is_describe: false
      },
      editor: ClassicEditor,
      editorConfig: {
        // Editor configuration
        toolbar: [
          'bold',
          'italic',
          '|',
          'mathType',
          'ChemType',
          'bulletedList',
          'numberedList',
          '|',
          'alignment',
          'outdent',
          'indent',
          'blockQuote',
          'insertTable',
          'undo',
          'redo'
        ]
      }
    }
  },
  created() {
    this.model = this.value
    if (_.isEmpty(this.edit_data)) {
      this.defaultAnswer()
    }
    this.setEdit()
  },
  computed: {
    ...mapState('eschool/eExam/question', [
      'letter',
      'number',
      'roman_number',
      'edit_data'
    ]),
    answerChunks() {
      return _.chunk(Object.values(this.model.answer_list), 2)
    }
  },
  methods: {
    defaultAnswer() {
      this.model.answer_list = []
      for (let i = 1; i <= this.min_answer_choice; i++) {
        this.model.answer_list.push(
          Object.assign({}, this.new_answer, {
            id: i,
            answer_prefix: this.answer_prefix[i - 1]
          })
        )
      }
    },
    removeAnswer(answer) {
      this.model.answer_list.splice(this.model.answer_list.indexOf(answer), 1)
      this.model.answer_list.map((item, index) => {
        ;(item.id = index + 1), (item.answer_prefix = this.answer_prefix[index])
      })
    },
    addAnswer() {
      this.model.answer_list.push(_.clone(this.new_answer))

      this.model.answer_list.map((item, index) => {
        ;(item.id = index + 1), (item.answer_prefix = this.answer_prefix[index])
      })
    },
    changeAnswerPrefix() {
      this.model.answer_list.map((item, index) => {
        item.answer_prefix = this.answer_prefix[index]
      })
    },
    setEdit() {
      if (!_.isEmpty(this.edit_data) && this.edit_data !== undefined) {
        this.model.answer_list = this.edit_data.answers.map((el, index) => ({
          id: index + 1,
          answer_id: el.answer_id,
          answer_prefix: el.answer_prefix,
          answers: el.answers,
          is_describe: el.is_describe,
          is_correct: el.is_correct,
          question_id: el.question_id
        }))

        this.selected = this.model.answer_list
          .filter(a => a.is_correct == true)
          .reduce((init, value) => (init = value), {}).id
      }
    }
  },
  watch: {
    selected(selected) {
      this.model.answer_list.forEach(answer => {
        answer.id == selected
          ? (answer.is_correct = true)
          : (answer.is_correct = false)
      })
    },
    'model.answer_option_id': function(val) {
      if (val == 1) {
        this.answer_prefix = this.letter
      }
      if (val == 2) {
        this.answer_prefix = this.number
      }
      if (val == 3) {
        this.answer_prefix = this.roman_number
      }
      this.changeAnswerPrefix()
    },
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
<style scoped>
.answer-contianer {
  max-height: 40vh;
}
</style>
